import React, { PureComponent } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { server, RECAPTCHA_KEY } from "../env";
import { Link } from "react-router-dom";

// helper components
import Loader from "../components/Loader";
import Recaptcha from "react-google-invisible-recaptcha";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class ResetPassword extends PureComponent {
  state = {
    showPassword: false,
    loader: "",
    message: "",
    reCaptcha: null,
  };

  notify = (message, type) => {
    toast(message, { type, theme: "colored" });
  };
  handlePasswordVisiblity = () => {
    this.setState({
      showPassword: this.state.showPassword ? false : true,
    });
  };

  reset = async (e) => {
    e.preventDefault();

    if (e.target.password.value !== e.target.cnfPassword.value) {
      this.notify("Password and Confirm Password do not match", "error");
      return;
    }

    this.setState({
      loader: <Loader />,
    });

    await this.recaptcha.execute();

    const params = {
      email: localStorage.getItem("email"),
      otp: e.target.otp.value,
      password: e.target.password.value,
      "g-recaptcha-response": this.state.reCaptcha,
    };

    await axios
      .post(server + "/v1/auth/reset-password", params)
      .then((rsp) => {
        this.notify(rsp.data.detail, "success");
        Cookies.set("token", rsp.data.payload.token);
        this.setState({
          loader: "",
        });
        window.location.href = "/";
      })
      .catch((err) => {
        if (err.response) {
          this.notify(err.response.data.detail, "error");
        }
        this.setState({
          loader: "",
        });
      });
  };

  onResolved = () => {
    this.setState({ reCaptcha: this.recaptcha.getResponse() });
  };

  render() {
    const { showPassword, loader } = this.state;

    return (
      <section className="login_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="notification_wrap error_wrap"></div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="signup_inner_wrap">
                <div className="signup_frm_wrap">
                  <form onSubmit={this.reset}>
                    <h6>Forgot Password?</h6>
                    <p>
                      Enter your registered email address <br />
                      to reset your password
                    </p>
                    <div className="form-group">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter the Recieved OTP"
                        name="otp"
                        autoFocus
                        required
                      />
                      <i className="fa fa-key"></i>
                    </div>

                    <div className="form-group">
                      <input
                        className="form-control"
                        type="password"
                        placeholder="Enter your password"
                        name="password"
                        required
                      />
                      <i className="fa fa-key"></i>
                    </div>

                    <div className="form-group">
                      <input
                        className="form-control"
                        type={showPassword ? "text" : "password"}
                        placeholder="Confirm Password"
                        name="cnfPassword"
                        required
                      />
                      <span
                        toggle="#password-field2"
                        className="toggle-password"
                        onClick={this.handlePasswordVisiblity}
                        id="myDIV2"
                      >
                        View
                      </span>
                    </div>

                    <div className="form-group ">
                      <button type="submit" className="btn btn_submit">
                        Submit {loader}
                      </button>
                    </div>
                    <div className="form-group mb-0">
                      <p>
                        Remember password? <Link to="/login">Login</Link>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer />
        <Recaptcha
          ref={(ref) => (this.recaptcha = ref)}
          sitekey={RECAPTCHA_KEY}
          onResolved={this.onResolved}
        />
      </section>
    );
  }
}

export default ResetPassword;
